import styled from 'styled-components';

export const Container = styled.div`
    display: ${({ isactive }) => (isactive ? 'grid' : 'none')};
    grid-template-columns: 1fr;
    justify-content: center;
    padding: 50px 50px 0;
`;
